import { AuthHttpClient } from './authHttpClient.service';
import { HttpClient, HttpHandler } from '@angular/common/http';

export function httpClientFactory(httpHandler: HttpHandler): HttpClient {
  return new AuthHttpClient(httpHandler);
}
